let curpage = {}, userinf = {};
let ctrler = 'index', action = 'index';
const URLPREFIX = '?admin=', HEADERH = 50;

function getHost(){
	return (process.env.NODE_ENV == 'development') ? '/index.php/' : window.apihost;
}

function parSearch(){
	let locstr = location.search.substr(1);
	if (! locstr.trim().length) return {};
	let resarr = {}, locarr = locstr.split('&');
	for (let i in locarr) {
		let [ky, val] = locarr[i].split('=');
		resarr[ky] = unescape(val)
	}
	return resarr
}

function resetSearch(queryobj){
	let _query = '', locsearch = parSearch();
	for (let ky in queryobj) {
		locsearch[ky] = encodeURIComponent(queryobj[ky])
	}
	for (let idx in locsearch) _query += `&${idx}=${locsearch[idx]}`;
	return '?' + _query.substr(1)
}

function isPreview(){
	let srhmap = parSearch();
	return srhmap['hash'] == 'preview'
}

function isEditor(){
	let pageid = '', srhmap = parSearch(),
	iid = srhmap['editor'] || '';
	if (iid && /^\d+$/i.test(iid)) pageid = iid;
	return pageid
}

function getModAct(){
	let srhmap = parSearch(), mastr = srhmap['admin'] || '';
	if (mastr && /^(\w+)\/(\w+)$/i.test(mastr)) {
		ctrler = RegExp.$1;
		action = RegExp.$2
	}
	return [ctrler, action]
}

function remoteUrl(short_path, type = 'api', param = {}){
	let host = (process.env.NODE_ENV == 'development') ? '/index.php/' : window.hosturl;
	let q = '', hosturl = (type == 'api') ? window.apihost : host;
	if (! $.isPlainObject(param)) param = {param};
	for (let k in param) q += `&${k}=` + encodeURIComponent(param[k]);
	return `${hosturl + short_path}?_ax=1${q}`
}

function remoteStaticUrl(short_path){
	return window.hosturl + short_path
}

function xhrPost(url, data, success, fail = $.noop){
	let host = getHost(), sid = getCookie('loginresponsid') || getCookie('PHPSESSID'),
	newdata = $.extend({}, data || {}, {sid});
	$.post(`${host + url}?_ax=1`, newdata, res => {
		if (! $.isPlainObject(res)) res = JSON.parse(res);
		if (res.result == 'ERROR' && res.errcode == -1000) {
			/*alert('登录超时，请重新登录。');
			location.reload();*/return false
		}
		$.isFunction(success) && success(res)
	}).fail(xhr => fail(`${xhr.statusText} (${xhr.status})`))
}

function getUserInfo(success, fail = $.noop){
	let loginuser = Object.assign({}, userinf);
	if (/^[1-9]\d*$/.test((loginuser.data||{}).id||0)) {
		success(loginuser);
		return false
	}

	(new Promise((resolve, reject) => {
      xhrPost('user/index', null,
        res => resolve(res),
        err => reject(err)
      )
    })).then(res => {
    	userinf = Object.assign({}, res);
    	let errmsg = res.errmsg || res.data.errmsg || '';
    	if (userinf.result == 'ERROR' && errmsg != 'unlogin') {
    		alert(errmsg);return false
    	}
		success(userinf)
	}, err => fail(err))
}

function ucFirst(str){
	if (!(str && str.trim().length)) return str;
	return str.charAt(0).toUpperCase() + str.substr(1)
}

function getCookie(key){
	let cookiesArray = document.cookie ? document.cookie.split('; ') : Array.prototype,
	i = 0, len = cookiesArray.length, item = [], value, tempKey;

	for (i; i < len; i++) {
		item = cookiesArray[i].split('=');
		tempKey = decodeURIComponent(item[0]);
		if (tempKey === key) {
			value = decodeURIComponent(item[1]);
			if (/[\{\[]/.test(value)) value = JSON.parse(value)
		}
	}

	return value
}

function fGuid(param){
	let fGuidCst = () => {
		let sGuid = '';
        for (let i = 1; i <= 32; i++) {
        	let nNum = 0;
			nNum = parseInt(Math.random() * 16);
			sGuid += nNum.toString(16);
			if ($.inArray(i, [8,12,16,20]) > -1) sGuid += '-'
        }
        return `\{${sGuid.toUpperCase()}\}`
	};
	let sGuid = fGuidCst();
	if (param) return sGuid;
	return `${sGuid}`.replace(/\{|\}|-/g, '')
}

function Page(pid){
	this.pageid = pid;
	this.pages = [];
    this.pageinfo = {};
    this.modinfo = [];
	this.rmids = [];
    this.fetchPageInf(pid);
}
Page.prototype.fetchPageInf = function(id){
	let self = this, host = getHost(),
	sid = getCookie('loginresponsid') || getCookie('PHPSESSID');
	$.ajax({
		async: false,
		type: 'POST',
		url: `${host}page/index?_ax=1`,
		data: {id, sid},
		success (res){
			let pid = parseInt(res.pageid || '0');
			if (pid) self.pageid = pid;
			self.pages = res.pages;
			self.pageinfo = res.pageinfo;
			self.modinfo = res.modinfo
		}
	})
};

function getCurPage(){
	let id = isEditor();
	if (curpage && curpage.pageid == id) return curpage;

	curpage = new Page(id);
	return curpage
}

function pageSave(vm, pageid){
	let curpage = getCurPage(),
	modstr = JSON.stringify(curpage.modinfo);

	xhrPost('page/save_layout', {
		"id": pageid,"mods": modstr,
		"rmids": curpage.rmids
	}, res => {
		if (res.result == "OK") {
			curpage.rmids = [];
			vm.$Message.success('保存成功');
			setTimeout(() => {
				let isdirect = res.data.isdirect || '1';
				if (isdirect === '1') {
					location.search = '?admin=wxapp/pages';
					return false
				}
				
				if (pageid != isEditor()) {
					location.search = resetSearch({'editor': pageid})
				}
			}, 100)
		} else vm.$Message.error('保存失败')
	}, err => console.error(err))
}

function pagelink(lnkobj){
	// for 'page-links'
	if (! $.isPlainObject(lnkobj) || $.isEmptyObject(lnkobj)) return false;
	
	let val = lnkobj.param.value || '';
	switch (lnkobj.type || 'none') {
		case 'page':
			if (!/^\d+$/.test(val)) return false;
			location.search = resetSearch({'editor': val})
			break;
        case 'func':
            let _type = lnkobj.param.type || '';
			if (! $.trim(val).length && _type == 'callto') return false;

            if (_type == 'callto') location.href = 'tel:' + val;
            else if (_type && lnkobj.param.pagevalue) {
                let pagevalue = lnkobj.param.pagevalue,
                idsvalue = lnkobj.param.idsvalue || [];

                let params = {'editor': pagevalue};
                if (idsvalue.length) params['id'] = idsvalue.toString();
                location.search = resetSearch(params)
            }
			break;
	}
}

function parseTime(t, spliter = '-'){
	let tt = new Date(t * 1000),
	strpad = n => (`${n}`.length>1?'':'0') + n,
	datestr = tt.getFullYear();
	datestr += spliter + strpad(tt.getMonth() + 1) + spliter + strpad(tt.getDate());
	datestr += ' ' + strpad(tt.getHours()) + ':' + strpad(tt.getMinutes());
	datestr += ':' + strpad(tt.getSeconds());
	return datestr
}

function checkSiteStatus(userinf = {}){
    let site_status = userinf.site_status || '0',
    expired_time = parseInt(userinf.expired_time || '0');
    if (isNaN(expired_time)) return '到期时间异常';

    let errmsg = '', msec = +(new Date()),
    curtime = parseInt(`${msec}`.substr(0, 10));
    if (site_status == '-1') errmsg = '该账户暂无法使用';
    else if (site_status == '0') errmsg = '该账户已被删除';
    else if (site_status == '2' || expired_time < curtime) errmsg = '该账户已过期';

    return errmsg
}

export default
{
	URLPREFIX,
	HEADERH,
	isEditor,
	isPreview,
	getModAct,
	xhrPost,
	getUserInfo,
	ucFirst,
	fGuid,
	getCurPage,
	pageSave,
	remoteUrl,
	remoteStaticUrl,
	getHost,
	parSearch,
	resetSearch,
	pagelink,
	parseTime,
	checkSiteStatus,
}


// WEBPACK FOOTER //
// ./src/global.js